module.exports = __webpack_public_path__ + "static/img/clothing_10.0f162b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_10.png
// module id = yd+t
// module chunks = 0